<div class="enquiry-dialog">
  <header class="dialog-header">
    <div>
      <p class="eyebrow">Website enquiry</p>
      <h2>{{contactName}}</h2>
      <div class="header-meta">
        <span>{{enquiry.dateCreated | date:'dd MMM yyyy, h:mm a'}}</span>
        <span *ngIf="enquiry.service" class="badge">{{enquiry.service}}</span>
        <span
          *ngIf="data.mayBeSpam !== null"
          class="spam-status"
          [class.spam-status--spam]="data.mayBeSpam === true"
          [class.spam-status--clear]="data.mayBeSpam === false">
          <mat-icon>{{data.mayBeSpam === true ? 'close' : 'check'}}</mat-icon>
          Spam check
        </span>
      </div>
    </div>
    <button mat-icon-button type="button" aria-label="Close" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <mat-dialog-content>
    <section class="content-grid">
      <div class="main-panel">
        <p class="label">Message</p>
        <div class="message">{{enquiry.message || 'No message supplied.'}}</div>
      </div>

      <aside class="side-panel">
        <div class="info-block">
          <p class="label">Contact</p>
          <a *ngIf="enquiry.email" [href]="emailHref">{{enquiry.email}}</a>
          <a *ngIf="enquiry.phone" [apPhone]="enquiry.phone">{{enquiry.phone | phone}}</a>
          <span *ngIf="enquiry.postcode">Postcode {{enquiry.postcode}}</span>
        </div>

        <div class="info-block">
          <p class="label">Status</p>
          <span>{{enquiry.status || 'new'}}</span>
          <span *ngIf="enquiry.id">Enquiry #{{enquiry.id}}</span>
          <span *ngIf="$any(enquiry).taskId">Task #{{$any(enquiry).taskId}}</span>
        </div>
      </aside>
    </section>

    <section class="raw-data" *ngIf="data.rawSubmittedData">
      <p class="label">Submitted data</p>
      <pre>{{data.rawSubmittedData}}</pre>
    </section>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button type="button" (click)="close()">Close</button>
    <button *ngIf="!isArchived" mat-stroked-button color="primary" type="button" (click)="close('make-task')" [disabled]="data.isMakingTask">
      <mat-icon>{{data.isMakingTask ? 'hourglass_empty' : 'task_alt'}}</mat-icon> Make Task
    </button>
    <button *ngIf="!isArchived" mat-stroked-button color="primary" type="button" (click)="close('archive')" [disabled]="data.isMakingTask">
      <mat-icon>archive</mat-icon> Archive
    </button>
    <button *ngIf="isArchived" mat-stroked-button color="primary" type="button" (click)="close('restore')">
      <mat-icon>unarchive</mat-icon> Restore
    </button>
  </mat-dialog-actions>
</div>
